/* Markieren ganzer Spielerprofile in der Kaderliste — reine Funktionen, kein DOM.
 *
 * Nichts davon wird gespeichert; der Zustand lebt nur im Speicher (composables/useSelection.js).
 * Ordnung, keine Sicherheit: Wer was teilen oder exportieren darf, regeln weiterhin die
 * Rechtefunktionen (permissions.js, playerListExport.js) und die Datenbank.
 */

import { ROLES } from './permissions.js';
import { isOutOfSquad } from './status.js';

/** Rollen mit Markier-Modus. Gäste sind externe Berater und Agenten: Sie sollen nichts weiterverteilen können. */
export const SELECT_ROLES = ['admin', 'board', 'data', 'staff'];

/** Darf diese Rolle Profile markieren? Unbekannte oder fehlende Rolle: nein. */
export function canSelectPlayers(role) {
  return ROLES.includes(role) && SELECT_ROLES.includes(role);
}

/** Dauer des langen Drückens (Millisekunden) und Wegstrecke, ab der es als Scrollen gilt (Pixel). */
export const LONG_PRESS_MS = 500;
export const LONG_PRESS_MOVE_PX = 10;

/** Hat sich der Finger so weit bewegt, dass es ein Scrollen ist und kein langes Drücken? */
export function movedTooFar(dx, dy, limit = LONG_PRESS_MOVE_PX) {
  return Math.hypot(dx, dy) > limit;
}

/** Nur der Kader ist markierbar: nicht freigegeben, nicht transferiert. */
export function isSelectable(player) {
  return !!player && !isOutOfSquad(player.status);
}

/**
 * Markierte IDs -> Spieler, in der Reihenfolge der übergebenen Liste. IDs, die nicht (mehr) in der
 * Kaderliste stehen — gelöscht, freigegeben, transferiert — werden stillschweigend ausgelassen.
 *
 * @param {Iterable} ids
 * @param {Array} players  die geladenen Spieler
 */
export function resolveSelection(ids, players) {
  const set = new Set(ids);
  return (players || []).filter((p) => p && set.has(p.id) && isSelectable(p));
}
